import ReportIcon from "@mui/icons-material/Assessment";
import ReportList from "./ReportList";

export default {
  icon: ReportIcon,
  list: ReportList,
};
